import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  verificationData: null,
  nin: "",
  tid: "",
};

const ninSlice = createSlice({
  name: "nin",
  initialState,
  reducers: {
    setVerificationData(state, action) {
      state.verificationData = action.payload.data;
      state.tid = action.payload.tid;
    },
    setNin(state, action) {
      state.nin = action.payload;
    },
  },
});

export const { setVerificationData, setNin } = ninSlice.actions;
export const selectNin = (state) => state.nin.nin;
export default ninSlice.reducer;
